/**
 * Minimal hash-based deep-linking, namespaced per app instance so multiple
 * shortcode embeds on one page don't collide. Reference stored as
 * `#<instanceKey>=<book>.<chapter>` inside the URL hash's query string.
 */
export function createRouter(instanceKey) {
	function readHash() {
		const raw = window.location.hash.replace(/^#/, '');
		const params = new URLSearchParams(raw);
		const value = params.get(instanceKey);
		if (!value) return null;

		const [book, chapter, translation] = value.split('.');
		if (!book || !chapter) return null;

		return { book, chapter: parseInt(chapter, 10) || 1, translation: translation || null };
	}

	function writeHash(book, chapter, translation) {
		const raw = window.location.hash.replace(/^#/, '');
		const params = new URLSearchParams(raw);
		params.set(instanceKey, `${book}.${chapter}.${translation}`);

		const next = '#' + params.toString();
		if (next !== window.location.hash) {
			history.replaceState(null, '', next);
		}
	}

	return { readHash, writeHash };
}
